import { useEffect, useState, useContext } from 'react'
import { useLocation } from 'react-router-dom'
import './CustomCursor.css'
import { ThemeContext } from '../../contexts/theme'

function CustomCursor() {
  const location = useLocation()
  const [position, setPosition] = useState({ x: 0, y: 0 })
  const [isVisible, setIsVisible] = useState(false)
  const [isHovering, setIsHovering] = useState(false)
  const [isButtonHover, setIsButtonHover] = useState(false)
  const [{ themeName }] = useContext(ThemeContext)

  const isDashboard = location.pathname.startsWith('/dashboard')

  useEffect(() => {
    if (isDashboard) return undefined

    const updateCursor = (e) => {
      setPosition({ x: e.clientX, y: e.clientY })
      setIsVisible(true)
    }

    const handleMouseEnter = () => setIsVisible(true)
    const handleMouseLeave = () => setIsVisible(false)

    const handleMouseOver = (e) => {
      const target = e.target
      const btnHero = target.closest('.btn--hero') || target.closest('.hero-resume-btn')

      if (btnHero) {
        setIsButtonHover(true)
        setIsHovering(true)
      } else if (
        target.tagName === 'A' ||
        target.tagName === 'BUTTON' ||
        target.closest('a') ||
        target.closest('button') ||
        target.closest('.btn') ||
        target.closest('.link')
      ) {
        setIsHovering(true)
        setIsButtonHover(false)
      } else {
        setIsHovering(false)
        setIsButtonHover(false)
      }
    }

    window.addEventListener('mousemove', updateCursor)
    window.addEventListener('mouseover', handleMouseOver)
    document.addEventListener('mouseenter', handleMouseEnter)
    document.addEventListener('mouseleave', handleMouseLeave)

    return () => {
      window.removeEventListener('mousemove', updateCursor)
      window.removeEventListener('mouseover', handleMouseOver)
      document.removeEventListener('mouseenter', handleMouseEnter)
      document.removeEventListener('mouseleave', handleMouseLeave)
    }
  }, [themeName, isDashboard])

  if (isDashboard) return null

  return (
    <div
      className={`custom-cursor ${isVisible ? 'visible' : ''} ${isHovering ? 'hover' : ''} ${isButtonHover ? 'button-hover' : ''}`}
      style={{
        left: `${position.x - 10}px`,
        top: `${position.y - 10}px`,
        rotate: '-180deg',
      }}
    >
      <svg width="28" height="28" viewBox="0 0 119 105" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <filter id="glow">
            <feGaussianBlur stdDeviation="2" result="coloredBlur" />
            <feMerge>
              <feMergeNode in="coloredBlur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <filter id="glow-sharp">
            <feGaussianBlur stdDeviation="0.5" result="coloredBlur" />
            <feMerge>
              <feMergeNode in="coloredBlur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.664 42.3949L59.4114 1.26865L118.264 103.194H0.558823L24.3062 62.0665L41.1046 71.7643L34.157 83.7971H84.6657L59.4114 40.0612L52.4637 52.094L35.664 42.3949Z"
          fill="currentColor"
          filter={isButtonHover ? 'url(#glow-sharp)' : 'url(#glow)'}
        />
      </svg>
    </div>
  )
}

export default CustomCursor
